import { ThemeLayout } from '../../front/lib/ThemeLayout';
import { createApp } from "vue";
import ListJobsApp from "./ListJobsApp.vue";
export const MIN_SEARCH_LENGTH = 2;
export const SEARCH_SPLIT_REGEX = /[\s,_-]+/g;
export function splitWords(str) {
    return str ? str.toLowerCase().split(SEARCH_SPLIT_REGEX).filter(w => w.length > MIN_SEARCH_LENGTH) : [];
}
export class ListJobs extends ThemeLayout {
    init() {
        this.prepareData();
        const rootEl = this.getElementById('app');
        const app = createApp(ListJobsApp, { listJobs: this });
        app.mount(rootEl);
    }
    prepareData() {
        var _a, _b, _c;
        for (const job of this.json.jobs) {
            job.municipality = this.json.municipalities.find(m => m.code === job.municipality_code);
            job.categories_names = this.json.terms.filter(term => job.categories_ids.includes(term.id)).map(term => term.name);
            job.search_terms = splitWords(job.title)
                .concat(splitWords(((_a = job.employer) === null || _a === void 0 ? void 0 : _a.title) || ''))
                .concat(splitWords(((_b = job.municipality) === null || _b === void 0 ? void 0 : _b.full_name) || ''))
                .concat(splitWords(job.excerpt || ''))
                .concat(((_c = job.categories_names) === null || _c === void 0 ? void 0 : _c.flatMap(splitWords)) || []);
        }
    }
}
